import Heading from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import styled from "styled-components"
import PartialDisplay from "components/PartialDisplay"

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 112px;
  width: 100%;
`

const UrlLink = styled.a`
  text-decoration: underline;
`

interface CellLinkProps {
  title?: string
  link?: string
  partial?: boolean
}

export const CellLink = (props: CellLinkProps) => {
  const { title, link, partial } = props

  return (
    <ContentColumn>
      <Heading variant="xs">{title}</Heading>
      <UrlLink href={link} target="_blank">
        <BodyText size="xs" color="primary-dark">
          {partial ? <PartialDisplay content={link} maxLength={20} /> : link}
        </BodyText>
      </UrlLink>
    </ContentColumn>
  )
}
